__turbopack_context__.v({
  "card": "EngagementModelCard-module-scss-module__PxgapG__card",
  "ellipseBottomRight": "EngagementModelCard-module-scss-module__PxgapG__ellipseBottomRight",
  "ellipseTopLeft": "EngagementModelCard-module-scss-module__PxgapG__ellipseTopLeft",
  "featureItem": "EngagementModelCard-module-scss-module__PxgapG__featureItem",
  "featureList": "EngagementModelCard-module-scss-module__PxgapG__featureList",
  "image": "EngagementModelCard-module-scss-module__PxgapG__image",
  "imageBox": "EngagementModelCard-module-scss-module__PxgapG__imageBox",
});
